export const actionTypes = {
  SEARCH_TAG_LIST_REQUEST: 'SEARCH_TAG_LIST_REQUEST',
  SEARCH_TAG_LIST_SUCCESS: 'SEARCH_TAG_LIST_SUCCESS',
  SEARCH_TAG_LIST_FAILURE: 'SEARCH_TAG_LIST_FAILURE',
};
